import { Icon } from '@chakra-ui/react';
import { CircleFlag } from 'react-circle-flags';
import type { ComponentProps } from 'react';
import type { ILanguage } from '@/types';

export const MbeFlag = (props: ComponentProps<ILanguage['icon']>): JSX.Element => (
  <Icon as={CircleFlag} cdnUrl="/images/flags/" {...props} />
);
